import { post, get } from "../../../../js/http";
import { getUrlParams, setMediaLen } from "../../../../js/util";
var page = 1;
getfreeCall(page);
function getfreeCall(page) {
  post("/ApiHome/ApiAction?_ControlName=GetUserCallService", {
    PageIndex: page,
    Position: 1001,
    PositionType: 1004,
    Sex: 0,
    MinAge: -1,
    MaxAge: -1,
    MinFeeAmount: -1,
    MaxFeeAmount: -1,
    PageSize: 6
  }).then(res => {
    res.Data.OnlyOneData.forEach(item => {
      if (item.MediaLength) {
        item.transMediaLength = setMediaLen(item.MediaLength);
      }
    });
    let experiTemplate = require("./couponExperienceList.art");
    var experiHtml = experiTemplate(res.Data);
    $("#couponExp-con").html(experiHtml);

    layui.use(["layer"], function() {
      var $ = layui.jquery,
        layer = layui.layer;
      layer.open({
        type: 1,
        skin: "layer-custom",
        btnAlign: "c",
        area: ["600px", ""],
        title: "",
        id: "couponExp",
        closeBtn: 2,
        content: $("#couponExp-con"),
        end: function() {
          $("#couponExp-con").hide();
        }
      });
    });

    $("#couponExp-con #changeAnother").off("click");
    $("#couponExp-con #changeAnother").click(function() {
      if (res.Data.OnlyOneData.length == 6) {
        getCallService(++page);
      } else {
        getCallService((page = 1));
      }
    });
  });
}

let audioSetInterval;
window.playVoice = function(el) {
  window.clearInterval(audioSetInterval);
  SetTimeL();
  let vblist = $(".voice-box");

  if (el.getAttribute("data-media") == $("#audioPlayer").attr("src")) {
    //同一个音频
    if ($(el).hasClass("pause")) {
      $(el)
        .removeClass("pause")
        .addClass("playing");
      $("#audioPlayer")[0].play();
      audioSetInterval = setInterval(Func, 1000);
    } else {
      $(el)
        .removeClass("playing")
        .addClass("pause");
      $("#audioPlayer")[0].pause();
    }
  } else {
    $(el)
      .removeClass("pause")
      .addClass("playing");
    $("#audioPlayer").attr("src", el.getAttribute("data-media"));
    $("#audioPlayer")[0].play();
    audioSetInterval = setInterval(Func, 1000);
  }
  if (vblist.length) {
    for (var i = 0; i < vblist.length; i++) {
      if (
        vblist[i].getAttribute("data-media") != $("#audioPlayer").attr("src")
      ) {
        $(vblist[i])
          .removeClass("playing")
          .addClass("pause");
      }
    }
  }

  function Func() {
    // 创建倒计时
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        if ($(vblist[i]).hasClass("playing")) {
          // 设置剩余时长
          let temp = Number(
            $(vblist[i])
              .find("label.timeL")
              .attr("data-ctime")
          );
          if (temp - 1 >= 0) {
            $(vblist[i])
              .find("label.timeL")
              .attr("data-ctime", temp - 1);
            $(vblist[i])
              .find("label.timeL")
              .text(setMediaLen(temp - 1));
          }
        }
      }
    }
  }

  function SetTimeL() {
    let vblist = $(".voice-box");
    if (vblist.length) {
      for (var i = 0; i < vblist.length; i++) {
        $(vblist[i])
          .find("label.timeL")
          .text(setMediaLen(vblist[i].getAttribute("data-time")));
      }
    }
  }
  var audio = document.getElementById("audioPlayer");
  if (audio) {
    audio.loop = false;
    audio.addEventListener(
      "ended",
      function() {
        console.log("结束");
        SetTimeL();
        //清除倒计时
        window.clearInterval(audioSetInterval);
        let vblist = $(".voice-box");
        if (vblist.length) {
          for (var i = 0; i < vblist.length; i++) {
            if (
              vblist[i].getAttribute("data-media") ==
              $("#audioPlayer").attr("src")
            ) {
              $(vblist[i])
                .removeClass("playing")
                .addClass("pause");
            }
          }
        }
        //在这个方法里写相应的逻辑就可以了
      },
      false
    );
  }
};
